import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React from "react";
import { connect } from "react-redux";
import { ACTION } from "../../../config/actions";
import { CRICKET_GAME, GAMES_TYPE, getCurrentIndexGame } from "../../../config/games";
import { NB_PLAYERS_MAX } from "../../../config/players";
import { THEMES_TYPE } from "../../../config/themes";
import i18n from "../../../i18n";
import * as actions from "../../../store/actions";
import DartSound from "../../DartSound/DartSound";
import "./Options.scss";


class Options extends React.Component {
  SoundPlayer = null;
  constructor(props) {
    super(props);
    document.getElementById("body").className = `${props.theme}`;

    this.state = {
      ...this.state,
      theme: props.theme,
      players: 2,
      themeValidated: false,
      playerValidated: false,
      gameType: CRICKET_GAME, //"301",
    };
  }
  componentDidUpdate(previousProps) {
    console.log(previousProps);
    const {
      action: { date: prevDate },
      target: { date: prevTargetDate }
    } = previousProps;
    const {
      action: { action, date },
      target: { date: targetDate, value, multiple }
    } = this.props;
    if (date !== prevDate) {
      this.handleKeyDown(action);
    }
    if (targetDate !== prevTargetDate) {
      this.handleKeyDown({ value, multiple });
    }
  }

  setSoundPlayer(track, theme) {
    if (this.SoundPlayer) {
      this.SoundPlayer.setTrack(track, theme);
    }
  }

  handleKeyDown = (action) => {
    let { playerValidated, themeValidated } = this.state;
    if (action === ACTION.OPTION) {
      if (!themeValidated) {
        this.handleChangeTheme();
      } else if (!playerValidated) {
        this.handleChangePlayer();
      } else {
        this.handleChangeGame();
      }
    }

    if (action === ACTION.START) {
      if (!themeValidated) {
        this.setState({ themeValidated: true });
      } else if (!playerValidated) {
        this.setState({ playerValidated: true });
      } else {
        this.startGameHandler();
      }
    }
    if (action === ACTION.CANCEL) {
      if (!playerValidated) {
        this.setState({ themeValidated: false });
      } else {
        this.setState({ playerValidated: false });
      }
    }
  }

  handleChangePlayer = (value) => {
    const { players } = this.state;

    let playerValidated = true;
    if (!value) {
      value = players === NB_PLAYERS_MAX ? 1 : players + 1;
      playerValidated = false;
    }
    this.setSoundPlayer("choice", this.state.theme);
    this.setState({ players: value, playerValidated });
  };

  handleChangeGame = (newScoreCount) => {
    if (!newScoreCount) {
      const value = getCurrentIndexGame(this.state.gameType);
      newScoreCount =
        value === GAMES_TYPE.length - 1
          ? GAMES_TYPE[0].value
          : GAMES_TYPE[value + 1].value;
    }
    this.setSoundPlayer("choice", this.state.theme);
    this.setState({
      gameType: newScoreCount,
    });
  };

  startGameHandler = () => {
    this.props.startGame(this.state);
    this.props.setAuth(true);
    // this.props.history.push("/scoreboard");
  };

  handleChangeTheme = (theme) => {
    let themeValidated = true;
    if (!theme) {
      const value = THEMES_TYPE.findIndex(
        (props) => props.value === this.state.theme
      );
      theme =
        value === THEMES_TYPE.length - 1
          ? THEMES_TYPE[0].value
          : THEMES_TYPE[value + 1].value;
      themeValidated = false;
    }
    document.getElementById("body").className = `${theme}`;
    this.props.setTheme(theme);
    this.setState({
      theme,
      themeValidated
    });
  }

  renderThemeChoice() {
    const { theme } = this.state;
    const playerButtonsProps = {
      handleChange: this.handleChangeTheme,
      items: THEMES_TYPE,
      currentValue: theme,
      labelField: i18n.t("APP.THEME_TYPE"),
    };

    return this.renderButtonsGroup(playerButtonsProps);
  }

  renderPlayerChoice() {
    const { players } = this.state;

    const items = [];
    for (let i = 1; i <= NB_PLAYERS_MAX; i++) {
      items.push({ value: i, label: i });
    }
    const playerButtonsProps = {
      handleChange: this.handleChangePlayer,
      items: items,
      currentValue: players,
      labelField: i18n.t("APP.NUMBER_OF_PLAYERS"),
    };

    return this.renderButtonsGroup(playerButtonsProps);
  }

  renderTitle() {
    return null;
  }

  renderGameChoice() {
    const { gameType } = this.state;
    const playerButtonsProps = {
      handleChange: this.handleChangeGame,
      items: GAMES_TYPE,
      currentValue: gameType,
      labelField: i18n.t("APP.GAME_TYPE"),
    };

    return (
      <>
        {this.renderButtonsGroup(playerButtonsProps)}
        <div className="options__action-container my-16">
          <Button
            variant="contained"
            color="primary"
            onClick={this.startGameHandler}
          >
            {i18n.t("APP.START_GAME")}
          </Button>
        </div>
      </>
    );
  }

  render() {
    const { themeValidated, playerValidated } = this.state;
    return (
      <div className="options--container">
        {this.renderThemeChoice()}
        {themeValidated && this.renderPlayerChoice()}
        <div className="options__players mb-12">
          <div className="options__select">
            {playerValidated && this.renderGameChoice()}
          </div>
        </div>
        <DartSound ref={(e) => (this.SoundPlayer = e)} key="contextSound" />
      </div>
    );
  }

  renderButtonsGroup = ({ items, currentValue, handleChange, labelField }) => {
    const children = [];
    items.forEach(({ label, value }) => {
      children.push(
        <MenuItem
          {...{
            key: `${label}${value}`,
            value: value,
          }}
        >
          {label}
        </MenuItem>
      );
    });

    const handleChangeValue = (e) => {
      let value = e && e.target && e.target.value;
      handleChange(value);
    };

    return (
      <div className="grid">
        <InputLabel id="demo-simple-select-label">{labelField}</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={currentValue}
          onChange={handleChangeValue}
        >
          {children}
        </Select>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setAuth: (auth) => dispatch(actions.setAuth(auth)),
    startGame: (options) => dispatch(actions.startGame(options)),
    setTheme: (options) => dispatch(actions.setTheme(options))
  };
};

const mapStateToProps = (state) => {
  return {
    ...state.scoreboard,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Options);
